import { Button, Flex, Form } from "antd";
import ContaViagemFormBasic, { IContaViagemFormBasicProps, IContaViagemFormBasicRef, IContaViagemFormType } from "./ContaViagemFormBasic";
import { useContaViagemBuscar, useContaViagemSalvar } from "@/Services/Domain/Viagem/Financeiro/ContaViagemService";
import { useCallback, useRef, useEffect } from "react";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";

type ContaViagemSalvarParametrosType = Parameters<typeof useContaViagemSalvar>[0];
type ButtonOnClickType = NonNullable<Parameters<typeof Button>[0]["onClick"]>;
export interface IContaViagemFormProps extends IContaViagemFormBasicProps {
    codigo ?: number;
    onCancelar ?: ButtonOnClickType;
    onSuccess?:ContaViagemSalvarParametrosType["onSuccess"],
    /** * @default true */
    renderizarAcoes ?: boolean;
}

export default function ContaViagemForm({
    codigo,
    form : formParam,
    onSuccess,
    onCancelar : onCancelarParam,
    renderizarAcoes,
    ...rest
}:IContaViagemFormProps) {
    renderizarAcoes = renderizarAcoes ?? true;
    const isAlteracao = codigo !== undefined && !isNaN(codigo) && isFinite(codigo) && codigo > 0;

    const refForm = useRef<IContaViagemFormBasicRef|null>(null);
    const [newForm] = Form.useForm<IContaViagemFormType>();
    const form = formParam ?? newForm;
    
    const onCancelar = useCallback<ButtonOnClickType>((e) => {
        form?.resetFields();

        onCancelarParam?.(e);
    }, [onCancelarParam]);

    const {
        data,
        isLoading,
        isFetching
    } = useContaViagemBuscar({
        codigo : isAlteracao ? codigo as number : -1,
        enabled : isAlteracao
    });

    const {
        isPending,
        mutate
    } = useContaViagemSalvar({
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables, context)
        }
    });

    useEffect(() => {
        if (isAlteracao) form.resetFields();
    }, [isAlteracao, data]);

    return <TelaCarregamento ativo={isPending || (isAlteracao ? (isLoading || isFetching) : false)}>
        <ContaViagemFormBasic
            {...rest}
            form={form}
            ref={refForm}
            initialValues={{
                codigo : isAlteracao ? codigo : undefined,
                contaViagem : isAlteracao ? data : undefined
            }}
            onFinish={(values) => {
                if ((values.codigo ?? 0) > 0)
                {
                    mutate({
                        contaViagem : {
                            ...values.contaViagem,
                            codigo : values.codigo ?? 0
                        }
                    });
                }
                else 
                {
                    mutate({
                        contaViagem : {
                            ...values.contaViagem,
                            codigo : values.codigo ?? 0
                        },
                        movimentacaoInicial : values.movimentacaoInicial
                    });
                }
            }}
        />
        {renderizarAcoes && <Flex gap="small" wrap="wrap" justify="center">
            <Button type="primary" danger htmlType="reset" onClick={(e) => { onCancelar?.(e) }}>
                Cancelar
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
                Salvar
            </Button>
        </Flex>}
    </TelaCarregamento>
}